module.exports = __webpack_public_path__ + "static/media/ic_edit.9b068c73.svg";